import React from "react";
import { useContext } from "react";
import {
  Drawer,
  TextField,
  Button,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  IconButton,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import styles from "./TransactionsFilter.module.css"; // Import the CSS module
import { DataContext } from "../../../context/dataprovider.js";

const TransactionsFilter = ({
  open,
  onClose,
  onApply,
  onReset,
  statusDef,
  home_filters,
}) => {
  const { userData = {} } = useContext(DataContext);
  const [filters, setFilters] = React.useState({
    ...home_filters,
  });

  const handleChange = (field) => (event) => {
    setFilters((prev) => ({
      ...prev,
      [field]: event.target.value,
    }));
  };

  const handleApply = () => {
    // console.log(`in Filter.js Applying Filters ${JSON.stringify(filters)}`);
    onApply(filters); // Pass filters to the parent component
    onClose();
  };

  const handleReset = () => {
    const defaultFilters = {
      senderName: null,
      status: null,
      fromDate: null,
      toDate: null,
      transId: null,
      projectId: null,
      payment_type: null,
      vendorname: null,
    };
    setFilters(defaultFilters);
    onReset(defaultFilters); // Notify parent about reset filters
    onClose();
  };
  const payment_type = [
    "General",
    "Material and PO Payment",
    "Site Expenditure",
    "UPI payment",
  ];
  return (
    <Drawer anchor="left" open={open} onClose={onClose}>
      <Box className={styles.drawerContainer}>
        <Box className={styles.header}>
          <Typography variant="h6">Filters</Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>
        <Box className={styles.form}>
          <TextField
            label="Sender Name"
            value={filters.senderName}
            onChange={handleChange("senderName")}
            fullWidth
          />
          <TextField
            label="Vendor Name"
            value={filters.vendorname}
            onChange={handleChange("vendorname")}
            fullWidth
          />

          <FormControl fullWidth>
            <InputLabel>Status</InputLabel>
            <Select
              value={filters.status}
              onChange={handleChange("status")}
              label="Status"
            >
              <MenuItem value="">All</MenuItem>
              {Object.values(statusDef).map((status) => (
                <MenuItem key={status} value={status}>
                  {status}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <TextField
            type="date"
            label="From Date"
            InputLabelProps={{ shrink: true }}
            value={filters.fromDate}
            onChange={handleChange("fromDate")}
            fullWidth
          />
          <TextField
            type="date"
            label="To Date"
            InputLabelProps={{ shrink: true }}
            value={filters.toDate}
            onChange={handleChange("toDate")}
            fullWidth
          />

          <TextField
            label="Transaction ID"
            value={filters.transId}
            onChange={handleChange("transId")}
            fullWidth
          />

          <FormControl fullWidth>
            <InputLabel>Project ID</InputLabel>
            <Select
              value={filters.projectId}
              onChange={handleChange("projectId")}
              label="Project ID"
            >
              <MenuItem value="">All</MenuItem>
              {userData.projectId &&
                userData.projectId.map((id) => (
                  <MenuItem key={id} value={id}>
                    {id}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>

          <FormControl fullWidth>
            <InputLabel>Payment Type</InputLabel>
            <Select
              value={filters.payment_type}
              onChange={handleChange("payment_type")}
              label="Project ID"
            >
              <MenuItem value="">All</MenuItem>
              {payment_type.map((id) => (
                <MenuItem key={id} value={id}>
                  {id}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <Box className={styles.buttonGroup}>
            <Button variant="contained" onClick={handleApply} fullWidth>
              Apply Filters
            </Button>
            <Button variant="outlined" onClick={handleReset} fullWidth>
              Reset
            </Button>
          </Box>
        </Box>
      </Box>
    </Drawer>
  );
};

export default TransactionsFilter;
